var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecordingResumeHovered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 12.601V3.3978C3.84375 2.72248 4.57631 2.30172 5.15964 2.642L13.0481 7.24359C13.6269 7.58123 13.6269 8.41756 13.0481 8.7552L5.15964 13.3568C4.57631 13.6971 3.84375 13.2763 3.84375 12.601Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordingResumeHovered);
export default __webpack_public_path__ + "static/media/icon-recording-resume-hovered.09c6f19527ce4b0df8492e331b03ddc2.svg";
export { ForwardRef as ReactComponent };